import { Component, ViewChild, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigurationClientService } from '../../services/client/configuration-client.service';
import { HasRoleDirective } from '../../common/directives/has-role.directive';

@Component({
  selector: 'app-main-layout',
  imports: [
    RouterModule,
    MatSidenavModule,
    MatButtonModule,
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    HasRoleDirective,
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  isSidenavOpened = true;
  isHandset = false;

  @Input() showAnalytics = false;
  @Input() showPrompts = true;
  @Input() showWorkspaces = true;
  showAgents = true;
  showProjects = true;
  @Input() chatMenuTitle: string | undefined = undefined;

  @ViewChild('sidenav') sidenav!: MatSidenav;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private snackBar: MatSnackBar,
    private router: Router,
    private config: ConfigurationClientService
  ) {}

  ngOnInit(): void {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isSidenavOpened = !result.matches;
        this.isHandset = result.matches;
      });

    if (!this.chatMenuTitle) {
      this.chatMenuTitle = this.config.getSetting('chat', 'defaultChatTitle');
    }
  }

  closeSidenavIfHandset() {
    if (this.isHandset) {
      this.sidenav.close();
    }
  }

  showComingSoonMessage(verticalPosition: 'top' | 'bottom' = 'top') {
    this.snackBar.open('Coming soon!', 'Close', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: verticalPosition,
    });
  }
}
